import React, { useContext, useEffect } from 'react';
import { PageSectionPB } from '../shared';
import { NationalAccountContext, NationalAccountProvider, } from '../../../contexts';
import { shared } from '../../../constants/NationalAccount';
import { EnrollModals, UnenrollModals, } from './components/NationalAccountModals';
import { NotEnrolledSummary, AlreadyEnrolledSummary, } from './components/PageSummaries';
import { usePricingContext } from '../../../contexts/pricing-context';
export var NationalAccount = function (_a) {
    var nationalAccount = _a.nationalAccount, isMobile = _a.isMobile;
    var shouldShowPricingBookPage = usePricingContext().shouldShowPricingBookPage;
    return (React.createElement(PageSectionPB, { title: shared.title, classes: shared.type === 'NAI' && shouldShowPricingBookPage
            ? ''
            : 'sui-pt-4 sui-mt-2', isMobile: isMobile, type: shared.type },
        React.createElement(NationalAccountProvider, null,
            React.createElement(NationalAccountPageAndModal, { nationalAccount: nationalAccount, isMobile: { isMobile: isMobile } }))));
};
var NationalAccountPageAndModal = function (_a) {
    var _b;
    var nationalAccount = _a.nationalAccount, isMobile = _a.isMobile;
    var _c = useContext(NationalAccountContext), setIsMobile = _c.setIsMobile, setCurrentAgreementCode = _c.setCurrentAgreementCode;
    useEffect(function () {
        setIsMobile(isMobile);
        setCurrentAgreementCode(nationalAccount === null || nationalAccount === void 0 ? void 0 : nationalAccount.agreementCodes[0]);
    }, [nationalAccount === null || nationalAccount === void 0 ? void 0 : nationalAccount.agreementCodes]);
    return (nationalAccount === null || nationalAccount === void 0 ? void 0 : nationalAccount.agreementCodes) &&
        ((_b = nationalAccount === null || nationalAccount === void 0 ? void 0 : nationalAccount.agreementCodes) === null || _b === void 0 ? void 0 : _b.length) > 0 ? (React.createElement(React.Fragment, null,
        React.createElement(AlreadyEnrolledSummary, null),
        React.createElement(UnenrollModals, null))) : (React.createElement(React.Fragment, null,
        React.createElement(NotEnrolledSummary, null),
        React.createElement(EnrollModals, null)));
};
